import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button_green from './UI/Button_green/Button_green';

const Confirm = () => {
    const navigate = useNavigate();

    return (
        <div className="confirm-page" style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', textAlign: 'center', fontFamily: 'Inter, sans-serif' }}>
            <h2 style={{ color: '#4CAF50', marginBottom: '20px', fontFamily: 'Inter, sans-serif' }}>Замовлення успішно оформлено!</h2>
            <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '18px', marginBottom: '30px' }}>
                Дякуємо за ваше замовлення. Ми зв'яжемося з вами найближчим часом.
            </p>
            <Button_green onClick={() => navigate('/')} style={{ marginTop: '20px' }}>
                ПОВЕРНУТИСЯ НА ГОЛОВНУ
            </Button_green>
        </div>
    );
};

export default Confirm;